import { lazy, Suspense, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { Route, Switch, useLocation } from 'react-router-dom'
import { ContentBox, GraceNotification } from './styles'
import { lazyLoader } from 'utils/storageUtils'
import MainmenuComponent from 'modules/mainmenu/MainmenuComponent'
import { setActiveTab_action, toggleMainMenu_action, changeTab_action, toggleSettingsModal_action, setResponseDropdoenStatus, setResponseDropdownPosition, setPageDropdownStatus, setPageDropdownPosition } from 'store/actions'
import ToolbarNav from './components/ToolbarNav'
import SettingsModal from 'modules/settings/SettingsModal'
import DraftPermissionsModal from 'modules/contents/DraftPermissionsModal'
import DeleteCategoryConfirmModal from 'modules/contents/DeleteCategoryConfirmModal'
import DeleteContentConfirmModal from 'modules/contents/DeleteContentConfirmModal'
import MoveToCategoryModal from 'modules/contents/MoveToCategoryModal'
import CategoryModal from 'modules/contents/CategoryModal'
import InviteTeammateModal from './components/InviteTeammateModal'
import ResponsePacksModal from '../templates/ResponsePacksModal'
import GlobalSearchModal from 'modules/contents/GlobalSearch/GlobalSearchModal'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import OnboardingPlansModal from 'modules/subscription/OnboardingPlansModal'
import GuestSharingModal from 'modules/contents/GuestSharingModal'
import OnboardingCreateItemsPopup from 'modules/contents/OnboardingCreateItemsPopup'
import ResponseCardDropdown from './components/ResponseCardDropdown'
import PageCardDropdown from './components/PageCardDropdown'

// Screens
const Home = lazy(() => import('./Home'))
const ResponseForm = lazy(() => import('modules/response/ResponseForm'))
const ResponseSingle = lazy(() => import('modules/response/ResponseSingle'))
const DraftForm = lazy(() => import('modules/pages/DraftForm'))
const CreateDraft = lazy(() => import('modules/pages/CreateDraft'))
const PublishedPage = lazy(() => import('modules/pages/PublishedPage'))
const CategoryPage = lazy(() => import('modules/contents/CategoryPage'))
const DraftsPage = lazy(() => import('modules/contents/DraftsPage'))
const TemplateForm = lazy(() => import('modules/templates/TemplateForm'))

const usePrevious = (value) => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  }, [value])
  return ref.current
}

export const App = (props) => {
  const { setActiveTab, app, toggleMainMenu, toggleTemplatesModal, toggleSettingsModal, toggleContentPermissionModal, free_items_limit, setResponseDropdoenStatus, setResponseDropdownPosition, setPageDropdownStatus, setPageDropdownPosition, fullScreenStatus } = props

  const activeTab = props.app.mainmenuTabs.filter((t) => t.isActive)[0];

  // set page title, close settings
  const { pathname } = useLocation()
  const prevPath = usePrevious(pathname)
  const [showGraceNotification, set_showGraceNotification] = useState(true)

  // Set activeTab
  useEffect(() => {
    if (prevPath !== pathname && pathname !== '/') {
      let activeTab = app.mainmenuTabs.filter((t) => t.isActive)[0]
      let index = 0
      if (pathname.includes('/page')) {
        index = app.mainmenuTabs.map((tab) => tab.key).indexOf('pages')
      } else if (pathname.includes('/response')) {
        index = app.mainmenuTabs.map((tab) => tab.key).indexOf('responses')
      }
      if (index !== -1) {
        activeTab = app.mainmenuTabs[index]
      }
      setActiveTab(activeTab.key)
      if (window.innerWidth < 576) {
        toggleMainMenu(false)
      }
    }
  }, [prevPath, pathname, setActiveTab, app.mainmenuTabs, toggleMainMenu, toggleTemplatesModal, toggleSettingsModal, toggleContentPermissionModal])
  // End.Set activeTab

  useEffect(() => {
    if (window.$chatway) {
      window.$chatway.updateChatwayCustomData('email', props?.company?.company?.owner?.email)
      window.$chatway.updateChatwayCustomData('name', props?.company?.company?.owner?.name)
    }
  }, [props?.company?.company, window.$chatway]);

  const closeGraceNotification = (e) => {
    e.preventDefault()
    set_showGraceNotification(false)
  }
  const dropdownRef = useRef(null);
  const currentPageIdRef = useRef(props.app?.currentPageDropdown?.id);

  const handlePageScroll = () => {
    closePageDropdownOnCertainRoute();

    if (props.app?.isPageDropdownVisible) {
      const buttonRect = document.getElementById(`pageDropdownButton-${currentPageIdRef.current}`)?.getBoundingClientRect();
      const sideMenu = document.querySelector('#pageScrollDiv')?.getBoundingClientRect();
      const left = buttonRect?.left + buttonRect?.width - sideMenu?.left;
      const top = buttonRect?.top + window.scrollY - sideMenu?.top;

      if (app.dropdownDirection === 'down') {
        if (sideMenu?.bottom - buttonRect?.bottom < 50) {
          setPageDropdownPosition({ left, top: top - 30 });
        } else {
          setPageDropdownPosition({ left, top: props.app?.currentPageDropdown.is_draft ? top : (top - 30) });
        }
      } else {
        setPageDropdownPosition({ left, top: top - 30 });
      }
    }
  };

  const closePageDropdownOnCertainRoute = () => {
    // if (window.location.pathname.startsWith('/page/') || window.location.pathname.startsWith('/drafts/') || window.location.pathname.startsWith('/pages/')) {
    if (window.location.pathname !== '/') {
      setPageDropdownStatus(false);
      document.body.style.overflow = 'auto';
    }
  }

  useEffect(() => {
    currentPageIdRef.current = props.app?.currentPageDropdown?.id;
    const handlePageOutsideClick = (event) => {
      if (event.target.className === 'dropdownChild' || (dropdownRef.current && dropdownRef.current.contains(event.target)) || event.target.closest(`#pageDropdownButton-${props.app?.currentPageDropdown?.id}`) !== null) {

        document.body.style.overflow = 'hidden'
        setPageDropdownStatus(true);

      } else {
        setPageDropdownStatus(false);

        // document.body.style.overflow = 'auto';
      }
    };

    const pageDivScroller = document.getElementById('pageScrollDiv');

    document.addEventListener('click', handlePageOutsideClick);
    pageDivScroller?.addEventListener('scroll', handlePageScroll);
    window.addEventListener('scroll', closePageDropdownOnCertainRoute)
    return () => {
      document.removeEventListener('click', handlePageOutsideClick);
      pageDivScroller?.addEventListener('scroll', handlePageScroll);
      window.addEventListener('scroll', closePageDropdownOnCertainRoute)
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.app?.currentPageDropdown?.id]);




  const handleResponseScroll = () => {
    closeResponseDropdownOnCertainRoute();

    if (props.app?.isResponseDropdownVisible) {
      const buttonRect = document.getElementById(`responseDropdownButton-${props.app?.currentResponseDropdown?.id}`)?.getBoundingClientRect();
      const sideMenu = document.querySelector('#responseScrollDiv')?.getBoundingClientRect();
      const left = buttonRect?.left + buttonRect.width - sideMenu?.left;
      const top = buttonRect.top + window.scrollY - sideMenu.top;
      // dropdownDirection

      if (app.dropdownDirection === 'down') {
        if (sideMenu.bottom - buttonRect.bottom < 50) {
          setResponseDropdownPosition({ left, top: top - 50 });
        } else {
          setResponseDropdownPosition({ left, top });
        }
      } else {
        setResponseDropdownPosition({ left, top: top - 50 });
      }
    }
  };

  const closeResponseDropdownOnCertainRoute = () => {

    // if (window.location.pathname.startsWith('/responses/create') || window.location.pathname.startsWith('/responses/edit') || window.location.pathname.startsWith('/response/')) {
    if (window.location.pathname !== '/') {
      document.body.style.overflow = 'auto';
      setResponseDropdoenStatus(false);
    }
  }

  useEffect(() => {
    const handleResponseOutsideClick = (event) => {
      if (event.target.className === 'dropdownChild' || (dropdownRef.current && dropdownRef.current.contains(event.target)) || event.target.id === `responseDropdownButton-${props.app?.currentResponseDropdown?.id}`) {

        setResponseDropdoenStatus(true);

      } else {
        setResponseDropdoenStatus(false);

        document.body.style.overflow = 'auto';
      }
    };

    const responseDivScroller = document.getElementById('responseScrollDiv');

    document.addEventListener('click', handleResponseOutsideClick);
    responseDivScroller?.addEventListener('scroll', handleResponseScroll);
    window.addEventListener('scroll', closeResponseDropdownOnCertainRoute)
    return () => {
      document.removeEventListener('click', handleResponseOutsideClick);
      responseDivScroller?.addEventListener('scroll', handleResponseScroll);
      window.addEventListener('scroll', closeResponseDropdownOnCertainRoute)
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.app?.currentResponseDropdown?.id]);


  return (
    <div className='app-box'>
      <Suspense fallback={lazyLoader()}>
        <MainmenuComponent />
      </Suspense>
      <ContentBox isMainMenuOpen={props.app.isMainMenuOpen}>
        {/* If company is on grace period */}
        {!props.isFree && !props.is_subscribed && props.isOnGracePeriod && showGraceNotification && pathname === '/' && (
          <GraceNotification>
            <div className='flex-fill'>
              We are launching our paid plans! Since you're an early bird user, you've got a grace period until July 1st, 2022.
              <br />
              You can always keep using our free forever plan (unlimited users, and up to {free_items_limit} items).{' '}
              <a
                href='/'
                className='font-weight-600 text-white'
                onClick={(e) => {
                  e.preventDefault()
                  props.changeTab('billing')
                  props.toggleSettingsModal(true)
                }}>{`Check plans >>`}</a>
            </div>
            <a href='/' className='close ml-auto' onClick={closeGraceNotification}>
              <CloseIcon />
            </a>
          </GraceNotification>
        )}

        {/* Toobar */}
        <ToolbarNav />

        {/* New/Custom Response Dropdown */}
        {(props.app?.isPageDropdownVisible && activeTab.key === 'pages') && (
          <div ref={dropdownRef} style={{ position: 'absolute', zIndex: fullScreenStatus ? '30000000000' : '1000', ...props.app?.pageDropdownPosition }}>
            <PageCardDropdown />
          </div>
        )}

        {/* New/Custom Page Dropdown */}
        {(props.app?.isResponseDropdownVisible && activeTab.key === 'responses') && (
          <div ref={dropdownRef} style={{ position: 'absolute', zIndex: fullScreenStatus ? '30000000000' : '1000', ...props.app?.responseDropdownPosition }}>
            <ResponseCardDropdown />
          </div>
        )}
        {/* Routes */}
        <div className='container-xxl container-fluid px-0 px-md-3'>
          <Suspense fallback={lazyLoader()}>
            <Switch>
              <Route exact path='/responses/create' render={(routerProps) => <ResponseForm {...routerProps} />} />
              <Route exact path='/responses/edit/:uuid?' render={(routerProps) => <ResponseForm {...routerProps} />} />
              <Route exact path='/response/:uuid' render={(routerProps) => <ResponseSingle {...routerProps} />} />
              <Route exact path='/pages/drafts/create/:template_uuid?' render={() => <CreateDraft />} />
              <Route exact path='/pages/drafts/edit/:uuid' render={() => <DraftForm />} />
              <Route exact path='/pages/templates/edit/:uuid' render={() => <TemplateForm />} />
              <Route exact path='/page/drafts/:type?' render={() => <DraftsPage />} />
              <Route exact path='/response/category/:uuid/:sub_cate_uuid?/:sub_sub_cate_uuid?' render={() => <CategoryPage />} />
              <Route exact path='/page/category/:uuid/:sub_cate_uuid?/:sub_sub_cate_uuid?' render={() => <CategoryPage />} />
              <Route exact path='/page/:uuid' render={() => <PublishedPage />} />
              <Route exact path='/' render={() => <Home />} />
            </Switch>
          </Suspense>
        </div>
      </ContentBox>

      {/* Settings */}
      {/* Response Permission Modal */}
      {props.settings.showSettingsModal && <SettingsModal />}

      {/* Response Category Modal */}
      {props.showCategoryModal && <CategoryModal />}

      {/* Response Permission Modal */}
      {props.showContentPermissionModal && <DraftPermissionsModal />}

      {/* Confirm Delete Content Modal */}
      {props.showDeleteContentConfirm && <DeleteContentConfirmModal />}

      {/* Confirm Delete Category Modal */}
      {props.showDeleteCategoryConfirm && <DeleteCategoryConfirmModal />}

      {/* Show Move to category modal */}
      {props.showMoveToCategoryModal && <MoveToCategoryModal />}

      {/* INVITE */}
      {props.app.showInviteMembersModal && <InviteTeammateModal />}

      {/* SHARE */}
      {props.showGuestSharingModal && <GuestSharingModal />}

      {/* Responses Packs */}
      {props.showResponseTemplates && <ResponsePacksModal />}

      {/* Plans popup after Onboarding */}
      {props.showOnboardingPlansPopup && !props.is_subscribed && <OnboardingPlansModal />}
      {props.showCreateItemPopup && <OnboardingCreateItemsPopup />}

      {/* Responses Packs */}
      <GlobalSearchModal />
    </div>
  )
}

const mapStateToProps = (state) => ({
  app: state.app,
  company: state.company,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  isFree: state.company.company.isFree,
  free_items_limit: state.company.company.free_items_limit,
  settings: state.settings,
  showResponseTemplates: state.templates.showResponseTemplates,
  location: state.router.location,
  is_subscribed: state.subscription.is_subscribed,
  showOnboardingPlansPopup: state.subscription.showOnboardingPlansPopup,
  showCreateItemPopup: state.subscription.showCreateItemPopup,

  showCategoryModal: state.contents.showCategoryModal,
  showContentPermissionModal: state.contents.showContentPermissionModal,
  showDeleteContentConfirm: state.contents.showDeleteContentConfirm,
  showDeleteCategoryConfirm: state.contents.showDeleteCategoryConfirm,
  showMoveToCategoryModal: state.contents.showMoveToCategoryModal,
  showGuestSharingModal: state.contents.showGuestSharingModal,
  fullScreenStatus: state.contents.isFullScreen
})

const mapDispatchToProps = (dispatch) => ({
  setActiveTab: (tab) => dispatch(setActiveTab_action(tab)),
  toggleMainMenu: (status) => dispatch(toggleMainMenu_action(status)),
  toggleSettingsModal: (status) => dispatch(toggleSettingsModal_action(status)),
  changeTab: (value) => dispatch(changeTab_action(value)),
  setResponseDropdoenStatus: (status) => dispatch(setResponseDropdoenStatus(status)),
  setResponseDropdownPosition: (position) => dispatch(setResponseDropdownPosition(position)),
  setPageDropdownStatus: (status) => dispatch(setPageDropdownStatus(status)),
  setPageDropdownPosition: (position) => dispatch(setPageDropdownPosition(position)),
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
